// src/components/sections/HeroSection.js
import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ content }) => {
  const {
    title,
    subtitle,
    text,
    buttonText,
    buttonLink,
    buttonStyle = 'primary',
    imageUrl,
    alignment = 'center'
  } = content;

  const alignmentClasses = {
    left: 'text-left items-start',
    center: 'text-center items-center',
    right: 'text-right items-end'
  };

  const buttonClasses = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
    outline: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-50',
    link: 'bg-transparent text-blue-600 hover:underline'
  };

  return (
    <div className={`flex flex-col ${alignmentClasses[alignment]} w-full py-16 px-4 relative`}>
      {imageUrl && (
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={imageUrl}
            alt={title || 'Hero background'}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>
      )}

      <div className={`relative z-10 max-w-4xl ${alignment === 'center' ? 'mx-auto' : ''}`}>
        {title && <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>}
        {subtitle && <h2 className="text-2xl md:text-3xl font-semibold mb-4">{subtitle}</h2>}
        {text && <p className="text-lg mb-8">{text}</p>}

        {buttonText && buttonLink && (
          <Link
            to={buttonLink.startsWith('http') ? buttonLink : `/${buttonLink.replace(/^\//, '')}`}
            className={`${buttonClasses[buttonStyle]} px-6 py-3 rounded font-bold`}
          >
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default HeroSection;